import { type CanonicalSchema, deepFreeze, CanonicalFieldType as T } from './canonical-schema.js'

/**
 * `user@1` — owned by the user bounded context (user-service, TO-402). One
 * record is one tenant user keyed by its lowercase `email`; `role` is a branch
 * role (`ORG_USER` | `ORG_MANAGER`) and `primaryOrgUnitCode` an organization
 * unit code. Lengths follow the `users` columns. APPEND-ONLY: never edit this
 * published version; publish `user.v2.ts` instead.
 */
export const USER_V1: CanonicalSchema = deepFreeze({
	name: 'user',
	version: 1,
	owner: 'user',
	fields: [
		{ name: 'email', type: T.STRING, required: true, nullable: false, maxLength: 320 },
		{ name: 'displayName', type: T.STRING, required: true, nullable: false, maxLength: 128 },
		{ name: 'role', type: T.STRING, required: true, nullable: false, maxLength: 32 },
		{ name: 'primaryOrgUnitCode', type: T.STRING, required: true, nullable: false, maxLength: 64 },
	],
})
